import ContentCardCollectionsTab from './ContentCardCollectionsTab';

export default ContentCardCollectionsTab;
